import { Component, signal } from '@angular/core';
import { SetpointsService } from 'app/shared/setpoints.service';
import { SetpointTemplateCategory } from 'app/classes/setpoint-template-category';

@Component({
  selector: 'app-org-setpoints',
  templateUrl: './org-setpoints.component.html',
  styleUrls: ['./org-setpoints.component.css'],
  providers: [],
  standalone: false
})
export class OrgSetpointsComponent {

  categories: SetpointTemplateCategory[];
  tabIndex = 0;
  isShowingDialog = signal<boolean>(false);
  category: SetpointTemplateCategory;

  constructor(public setpointsService: SetpointsService) {
    this.get();
  }

  get() {
    this.setpointsService.getTemplateCategories().then(categories => this.categories = categories);
  }

  create() {
    this.category = new SetpointTemplateCategory();
    this.isShowingDialog.set(true);
  }

  onClose(ev: any) {
    this.isShowingDialog.set(false);
    this.get();
  }
}
